module.exports = __webpack_public_path__ + "img/261-1.5815fe7d.png";